import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { GRID_AREA_ACTION } from 'shared/components/Tile/components/Header/constants';

export const Action = styled(Box)({
  gridArea: GRID_AREA_ACTION,
});
